<template lang="pug">
  .address-layout
    .header.white
      v-container.pa-0(style="max-width:600px")
        head-bar
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    v-container(v-else style="max-width:600px")
      div.text-center
        div.caption Total Amount
        div.display-1.font-weight-bold {{ totalPrice | displayPrice($currency) }}
        div.caption(v-if="promoDiscountPrice") Promo Discount: {{ promoDiscountPrice | displayPrice($currency) }}
        div.caption(v-if="discountPrice") Discount: {{ discountPrice | displayPrice($currency) }}
        div.caption(v-if="taxAmount") Tax: {{ taxAmount }}%
        div.caption(v-if="shippingFee") Delivery Charge: {{ shippingFee | displayPrice($currency) }}
        .installment.grey.lighten-2.mt-2.py-2(v-if="paymentAmount && lead.installment")
          div.caption Amount to be paid today
          div.display-1.font-weight-bold {{ paymentAmount | displayPrice($currency) }}
        p.caption.mt-3.mb-0(v-if="lead.email") Email: {{ lead.email }}
        p.mt-0.caption Phone: {{ lead.phone | phoneFormat }}

      v-card(outlined)
        v-simple-table
          thead
            tr
              th.text-center.basic400(style="width: 10%") No
              th.basic400 Item
              th.text-center.basic400 Qty
              th.basic400 Amount

          tbody(v-if="invoice")
            tr(v-for="(item, index) in invoice.products" :key="item.name+index")
              td.text-center.py-1
                div {{ index + 1 }}
              td.py-1
                div {{ item.name }}
                template(v-if="item.addons.length > 0")
                  div.text-caption(v-for="addon in item.addons") + {{ addon.name }}
              td.text-center.py-1
                div x {{ item.quantity }}
              td.py-1
                div {{ item.price_per_set * item.quantity | displayPrice($currency) }}

      v-form.mt-4(ref="form")
        div.title.text-center.font-weight-bold(id="payment-method") Choose Payment Method
        div.mt-4.label.basic600--text Select Payment Method
        v-select.mt-2(v-model='paymentMethod' placeholder="Select Payment Method" background-color="basic200" height="40" outlined dense item-text="name" item-value="value" :items="paymentMethods" :rules="rules.not_empty" @change="changePaymentMethod")

        .online-payment(v-show="paymentMethod == 'fpx' || paymentMethod == '2c2p'")
          v-card.mb-12
            v-list.pa-0
              v-list-item-group(v-model='selectedBankIndex', color='primary')
                template(v-for='(bank, index) in banks')
                  v-divider(v-if="index != 0")
                  v-list-item(:key='bank.code' v-slot:default='{ active, toggle }')
                    v-list-item-icon
                      v-card
                        v-img(:src="bank.image ? bank.image : require('@/assets/image_placeholder.png')" width=48, height=48)
                    v-list-item-content
                      v-list-item-title(v-text='bank.name')
                    v-list-item-action(v-show="active")
                      v-btn(icon)
                        v-icon(color='success') mdi-check

        .credit-debit-card(v-show="paymentMethod == 'ctdt'")
          v-card.mb-12
            v-list.pa-0
              v-list-item
                v-list-item-icon
                  v-card
                    v-img(:src="creditDebit.image ? creditDebit.image : require('@/assets/image_placeholder.png')" width=48, height=48)
                v-list-item-content
                  v-list-item-title(v-text='creditDebit.name')
                v-list-item-action
                  v-btn(icon)
                    v-icon(color='success') mdi-check

        .manual-payment(v-show="paymentMethod == 'bank_transfer'")
          p.caption.mx-1 Transfer to any of the following bank account(s) and send receipt to
            a(@click="clickSendReceipt()")  {{ lead.form.company.name }}
          v-card.mb-12(outlined)
            v-simple-table.mb-2
              thead
                tr
                  //- th.text-center.basic400(style="width: 10%") No
                  th.basic400.pr-1 Bank
                  th.basic400.px-1 Account Details
                  //- th.basic400 Account name
                  th.basic400.pl-1.text-right Copy

              tbody
                tr(v-for="(bank, index) in bankList" :key="bank.id")
                  //- td.text-center
                    div {{ index + 1 }}
                  td.pr-1
                    div.p2 {{ bank.bank_name }}
                  td.px-1
                    div.p2 {{ bank.account_name }}
                    div.label.primary400--text {{ bank.bank_account }}
                  //- td
                    div {{ bank.account_name }}
                  td.pl-1(align="right")
                    div
                      v-btn(icon small @click="clickCopyBankNo(bank.bank_account)" v-clipboard:copy="bank.bank_account")
                        v-icon mdi-content-copy

        .cod(v-show="paymentMethod == 'cod' || paymentMethod == 'pas'")
          p.caption.mx-1.mb-12 Make sure all filled in informations is correct and inform 
            a.mr-1(@click="paymentMethod == 'cod' ? clickConfirmCod() : clickSendReceipt()") {{ lead.form.company.name }}
            | to proceed your order.

      v-footer.white(fixed app)
        v-container.px-0(style="max-width:580px")
          .online-payment(v-if="paymentMethod == 'fpx' || paymentMethod == '2c2p'")
            v-btn.textColorAccent.white--text(block @click="proceedToPay('onlinebank')" :disabled="!banks[selectedBankIndex]") {{ $t('proceed_to_pay') }}
          .credit-debit-card(v-if="paymentMethod == 'ctdt'")
            v-btn.textColorAccent.white--text(block @click="proceedToPay('creditdebit')") {{ $t('proceed_to_pay') }}
          .manual-payment(v-show="paymentMethod == 'bank_transfer'")
            v-btn.textColorAccent.white--text(block @click="clickSendReceipt()") {{ $t('send_receipt') }}
          .cod(v-show="paymentMethod == 'cod'")
            v-btn.textColorAccent.white--text(block @click="clickConfirmCod()") {{ $t('place_order') }}
          .cod(v-show="paymentMethod == 'pas'")
            v-btn.textColorAccent.white--text(block @click="clickConfirmPas()") {{ $t('place_order') }}

    .modals
      y-dialog(v-model='isProcessing' persistent width='300')
        v-card(color='primary' dark)
          v-card-text.pt-3
            | Processing payment...
            v-progress-linear.mb-0.mt-4(indeterminate='', color='white')
            div.mt-4.font-weight-bold Please do not refresh or navigate away from this screen

</template>

<script>
import { mapActions } from 'vuex'
import HeadBar from '@/components/forms/HeadBar.vue'

export default {
  name: 'PayInvoice',
  components: { HeadBar },
  props: ['lead'],
  data: () => ({
    isFetching: true,
    invoice: null,
    paymentMethod: null,
    paymentMethods: [],
    paymentProvider: '',
    selectedBankIndex: null,
    isProcessing: false,
    bankList: [],
    company: null,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required']
    },
    bankImages: [
      { name: '2C2P Payment Gateway', image: require('@/assets/images/fpx/2c2p.png') },
      { name: 'Affin Bank', image: require('@/assets/images/fpx/ABB0233.png') },
      { name: 'Alliance Bank', image: require('@/assets/images/fpx/ABMB0212.png') },
      { name: 'Alliance Bank Malaysia', image: require('@/assets/images/fpx/ABMB0212.png') },
      { name: 'AGRONet', image: require('@/assets/images/fpx/AGRO01.png') },
      { name: 'AmBank', image: require('@/assets/images/fpx/AMBB0209.png') },
      { name: 'CIMB Clicks', image: require('@/assets/images/fpx/BCBB0235.png') },
      { name: 'CIMB', image: require('@/assets/images/fpx/BCBB0235.png') },
      { name: 'Bank Islam', image: require('@/assets/images/fpx/BIMB0340.png') },
      { name: 'Bank Islam Malaysia', image: require('@/assets/images/fpx/BIMB0340.png') },
      { name: 'Bank Rakyat', image: require('@/assets/images/fpx/BKRM0602.png') },
      { name: 'Bank Muamalat', image: require('@/assets/images/fpx/BMMB0341.png') },
      { name: 'Bank Muamalat Malaysia', image: require('@/assets/images/fpx/BMMB0341.png') },
      { name: 'BSN', image: require('@/assets/images/fpx/BSN0601.png') },
      { name: 'Bank Simpanan Nasional', image: require('@/assets/images/fpx/BSN0601.png') },
      { name: 'Hong Leong Bank', image: require('@/assets/images/fpx/HLB0224.png') },
      { name: 'HSBC Bank', image: require('@/assets/images/fpx/HSBC0223.png') },
      { name: 'HSBC', image: require('@/assets/images/fpx/HSBC0223.png') },
      { name: 'KFH', image: require('@/assets/images/fpx/KFH0346.png') },
      { name: 'Kuwait Finance House', image: require('@/assets/images/fpx/KFH0346.png') },
      { name: 'Maybank2E', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'Maybank2U', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'Maybank', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'OCBC Bank', image: require('@/assets/images/fpx/OCBC0229.png') },
      { name: 'Public Bank', image: require('@/assets/images/fpx/PBB0233.png') },
      { name: 'RHB Now', image: require('@/assets/images/fpx/RHB0218.png') },
      { name: 'RHB Bank', image: require('@/assets/images/fpx/RHB0218.png') },
      { name: 'Standard Chartered', image: require('@/assets/images/fpx/SCB0216.png') },
      { name: 'UOB Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      { name: 'United Overseas Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      { name: 'PayPal', image: require('@/assets/images/fpx/Paypal.png') },
      { name: 'Visa / Mastercard', image: require('@/assets/images/fpx/VISA-MC.png') }
    ],
    banks: [],
    creditDebit: {},
    options: {
      duration: 800,
      offset: 0,
      easing: 'easeInOutQuart'
    },
  }),
  computed: {
    shippingFee() {
      if (!this.invoice) return 0
      return this.invoice.shipping_fee
    },
    discountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_discount
    },
    promoDiscountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_promo_discount
    },
    subtotalPrice() {
      if (!this.invoice) return 0
      return this.invoice.subtotal_amount
    },
    totalPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_amount
    },
    amountDue() {
      if (!this.invoice) return 0
      return this.invoice.total_amount - this.invoice.total_paid
    },
    taxAmount() {
      if (!this.invoice) return 0
      return this.invoice.company.tax_rate
    },
    minPaymentAmount() {
      if (!this.invoice.minimum_payment) return 0
      if (this.invoice.minimum_payment > this.amountDue) {
        return this.amountDue
      }
      return this.invoice.minimum_payment
    },
    paymentAmount () {
      if (this.$route.query.amount && this.lead.installment) {
        if (parseInt(this.$route.query.amount) >= this.amountDue) {
          if (this.amountDue == this.totalPrice) {
            return null
          }
          return this.amountDue
        }
        if (parseInt(this.$route.query.amount) < this.minPaymentAmount) {
          if (this.minPaymentAmount == this.totalPrice) {
            return null
          }
          return this.minPaymentAmount
        }
        return this.$route.query.amount
      }
      if (this.amountDue != this.totalPrice) {
        return this.amountDue
      }
      return null
    }
  },
  mounted () {
    this.getInvoice()
    this.company = this.lead.form.company
    this.paymentProvider = this.company.default_payment_gateway
    if (this.lead.allow_cod) {
      this.paymentMethods.push({
        name: 'Cash on Delivery (COD)',
        value: 'cod'
      })
    }
    if (this.lead.allow_pay_at_shop) {
      this.paymentMethods.push({
        name: 'Pay at Shop',
        value: 'pas'
      })
    }
    if (this.paymentProvider) {
      if (this.paymentProvider == 'twoctwop') {
        this.paymentMethods.push({
          name: 'Credit/Debit Card or Online Banking (Malaysia)',
          value: '2c2p'
        })
      } else {
        this.paymentMethods.push({
          name: 'Online Banking (Malaysia)',
          value: 'fpx'
        })
      }
    }
    this.getSupportedBank()
    this.$axios.get(`/leads/${this.lead.pid}/directpay/?count=100`)
      .then((response) => {
        response.data.results.forEach(bank => {
          if (bank.enabled) {
            this.bankList.push(bank)
          }
        })
        if (this.bankList.length > 0) {
          this.paymentMethods.push({
            name: 'Bank Transfer',
            value: 'bank_transfer'
          })
        }
      }).catch(() => {})
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getInvoice () {
      this.$axios.get(`/invoices/${this.lead.pid}/`)
        .then((response) => {
          this.isFetching = false
          this.invoice = response.data
          //out of stock
          for (let i = 0; i < this.invoice.products.length; i++) {
            let p = this.invoice.products[i]
            if (p.product.inventory_enabled && p.product.inventory_qty < p.quantity) {
              this.showMessage(['error', this.$t('error_message.not_enough_stock')])
              location.href = `/invoices/${this.lead.pid}`
            }
          }
        }).catch(() => {})
    },
    getSupportedBank() {
      if (!this.paymentProvider || this.paymentProvider == null) {
        return
      }
      this.$axios.get(`/banks/?gateway=${this.paymentProvider}&active=true&staging=false&company=${this.company.id}`)
        .then((resp) => {
          resp.data.results.forEach(bank => {
            const selectedBank = this.bankImages.filter((obj) => {
              return obj.name.toLowerCase() == bank.name.toLowerCase()
            })
            bank['image'] = ''
            if (selectedBank.length != 0) {
              bank['image'] = selectedBank[0].image
            }
            if (bank.category === 'senangpay') {
              this.creditDebit = { ...bank }
              this.paymentMethods.push({
                name: 'Credit / Debit Card',
                value: 'ctdt'
              })
            } else {
              this.banks.push(bank)
            }
          })
        }).catch(() => {})
    },
    changePaymentMethod () {
      this.$vuetify.goTo('#payment-method', this.options)
    },
    clickCopyBankNo (bankNo) {
      this.showMessage(['success', `Copied: ${bankNo}`])
    },
    clickSendReceipt () {
      let storeUrl = process.env.VUE_APP_ENV === 'test' ? `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.lead.pid}?store` : `https://yezza.store/${this.lead.pid}`
      let message = `Hi, I have made the payment. Please check your bank account.%0d%0a%0d%0a${encodeURIComponent(`Order Form: ${storeUrl}`)}`
      location.href = `https://api.whatsapp.com/send?phone=${this.lead.member.phone}&text=${message}`
    },
    getShareMessage () {
      let message = `${encodeURIComponent('#')}${this.lead.rid}%0d%0a%0d%0a*Order for delivery*%0d%0a`
      let productMessage = ''
      let count = 1
      this.lead.products.forEach(prod => {
        productMessage = productMessage.concat(`${count}. ${prod.name} (x${prod.quantity})%0d%0a`)
        count ++
      })
      message = message.concat(`${productMessage}%0d%0a`)

      let customer = `*Customer:*%0d%0aName: ${this.lead.name}%0d%0aPhone: ${this.lead.phone}%0d%0a%0d%0a`
      message = message.concat(customer)
      if (this.lead.shipping_address) {
        let address = `*Address:*%0d%0a${this.lead.shipping_address.address_1},${this.lead.shipping_address.address_2 ? `%0d%0a${this.lead.shipping_address.address_2},` : ''}%0d%0a${this.lead.shipping_address.postcode}${this.lead.shipping_address.area ? ` ${this.lead.shipping_address.area},%0d%0a${this.lead.shipping_address.suburb}, ` : ''} ${this.lead.shipping_address.city},%0d%0a${this.lead.shipping_address.state}, ${this.lead.shipping_address.country}.%0d%0a%0d%0a`
        message = message.concat(address)
      }
      let payment = 'Payment: *Paid*'
      if (this.lead.cod) {
        payment = `Payment: COD%0d%0aAmount: *${this.$options.filters.displayPrice(this.invoice.total_amount, this.$currency)}*`
      }
      message = message.concat(payment)
      return message
    },
    clickConfirmCod () {
      this.axios.patch(`/leads/${this.lead.pid}/`, { cod: true, status: 'processed' })
        .then(() => {
          let storeUrl = process.env.VUE_APP_ENV === 'test' ? `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.lead.pid}?store` : `https://yezza.store/${this.lead.pid}`
          let message = `Cash On Delivery details:%0d%0a%0d%0a${encodeURIComponent(`Order Form: ${storeUrl}`)}%0d%0a%0d%0a`
          let productMessage = ''
          let count = 1
          this.lead.products.forEach(prod => {
            productMessage = productMessage.concat(`${count}. ${prod.name} (x${prod.quantity})%0d%0a`)
            count ++
          })
          message = message.concat(`${productMessage}%0d%0a`)
          let customer = `*Customer:*%0d%0aName: ${this.lead.name}%0d%0aPhone: ${this.lead.phone}%0d%0a%0d%0a`
          message = message.concat(customer)
          if (this.lead.shipping_address) {
            let address = `*Address:*%0d%0a${this.lead.shipping_address.address_1},${this.lead.shipping_address.address_2 ? `%0d%0a${this.lead.shipping_address.address_2},` : ''}%0d%0a${this.lead.shipping_address.postcode}${this.lead.shipping_address.area ? ` ${this.lead.shipping_address.area},%0d%0a${this.lead.shipping_address.suburb}, ` : ''} ${this.lead.shipping_address.city},%0d%0a${this.lead.shipping_address.state}, ${this.lead.shipping_address.country}.%0d%0a%0d%0a`
            message = message.concat(address)
          }
          let payment = `Payment: COD%0d%0aAmount: *${this.$options.filters.displayPrice(this.invoice.total_amount, this.$currency)}*`
          message = message.concat(payment)
          
          location.href = `https://api.whatsapp.com/send?phone=${this.lead.member.phone}&text=${message}`
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    clickConfirmPas () {
      this.axios.patch(`/leads/${this.lead.pid}/`, { pay_at_shop: true, status: 'processed' })
        .then(() => {
          let storeUrl = process.env.VUE_APP_ENV === 'test' ? `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.lead.pid}?store` : `https://yezza.store/${this.lead.pid}`
          let message = `Hi, I would like to pay at shop.%0d%0a%0d%0a${encodeURIComponent(`Order Form: ${storeUrl}`)}%0d%0a%0d%0a`
          let productMessage = ''
          let count = 1
          this.lead.products.forEach(prod => {
            productMessage = productMessage.concat(`${count}. ${prod.name} (x${prod.quantity})%0d%0a`)
            count ++
          })
          message = message.concat(`${productMessage}%0d%0a`)
          let customer = `*Customer:*%0d%0aName: ${this.lead.name}%0d%0aPhone: ${this.lead.phone}%0d%0a%0d%0a`
          message = message.concat(customer)
          let payment = `Payment: COD%0d%0aAmount: *${this.$options.filters.displayPrice(this.invoice.total_amount, this.currency)}*`
          message = message.concat(payment)
          
          location.href = `https://api.whatsapp.com/send?phone=${this.lead.member.phone}&text=${message}`
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    proceedToPay (reff) {
      if (!this.$refs.form.validate()) {
        return
      }
      let bcode = null
      if (reff === 'onlinebank') {
        bcode = this.banks[this.selectedBankIndex].code
      } else if (reff === 'creditdebit') {
        bcode = this.creditDebit.code
      }
      this.isProcessing = true
      const params = {
        gateway: this.paymentProvider,
        bank_code: bcode,
        description: `#${this.lead.rid} ${this.lead.name} from yezza`,
        lead: this.lead.id
      }
      if (this.paymentAmount) {
        params['amount'] = this.paymentAmount
      }
      this.$axios.post(`/transactions/`, params)
        .then((resp) => {
          const uid = resp.data.uid
          this.$axios.get(`/transactions/${uid}/pay/`)
            .then((resp) => {
              const data = resp.data
              if (data.action === 'POST') {
                this.postData(data)
              } else if (data.action === 'GET') {
                location.href = data.url
              }
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.isProcessing = false
            })
        })
        .catch((err) =>{
          console.log(err.response.data)
          if (err.response.data.message) {
            this.showMessage(['error', err.response.data.message])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
          this.isProcessing = false
        })
    },
    postData (data) {
      let form = document.createElement('form')
      form.method = 'POST'
      form.action = data.url
      Object.keys(data.payload).forEach(k => {
        let el = document.createElement('input')
        el.name = k
        el.value = data.payload[k]
        form.appendChild(el)
      })
      document.body.appendChild(form)
      form.submit()
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    },
    "proceed_to_pay": "Proceed To Pay",
    "send_receipt": "Send Receipt",
    "place_order": "Place Order"
  },
  "id": {
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    },
    "proceed_to_pay": "Teruskan pembayaran",
    "send_receipt": "Hantar tanda terima",
    "place_order": "Bayar"
  }
}
</i18n>